import React, { Fragment, FunctionComponent, ReactNode } from "react";
import useViewportCategory, {
  DESKTOP,
  MOBILE,
  TABLET,
} from "../../../hooks/viewport/useViewportCategory";
import { ViewportRestrictorProps } from "./ViewportRestrictor";

type Children = {
  children: ReactNode;
};

type CreateViewportRestrictor = (
  displayName: string,
  settings: ViewportRestrictorProps
) => FunctionComponent<Children>;

const createViewportRestrictor: CreateViewportRestrictor = (
  displayName,
  { showOnDesktop = false, showOnTablet = false, showOnMobile = false }
) => {
  const Component: FunctionComponent<Children> = ({ children }) => {
    const viewportCategory = useViewportCategory();

    if (viewportCategory === DESKTOP && !showOnDesktop) return null;
    if (viewportCategory === MOBILE && !showOnMobile) return null;
    if (viewportCategory === TABLET && !showOnTablet) return null;

    return <Fragment>{children}</Fragment>;
  };

  Component.displayName = displayName;

  return Component;
};

export default createViewportRestrictor;
